
const scope = 'SettingPages'
export const GET_SETTING_REQUEST = `${scope}/GET_SETTING_REQUEST`;
export const GET_SETTING_SUCCESS = `${scope}/GET_SETTING_SUCCESS`;
export const GET_SETTING_FAIL = `${scope}/GET_SETTING_FAIL`;
